// material-ui
import { Container, Grid, Typography } from "@mui/material";

// third party
import { motion } from "framer-motion";

// ==============================|| LANDING - NUMBER BLOCK PAGE ||============================== //

const NumberBlock = () => (
  <Container>
    <Grid
      container
      alignItems="center"
      spacing={2}
      sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}
    >
      <Grid item xs={12} sm={6} md={4}>
        <div>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Typography
                variant="h2"
                sx={{ minWidth: 80, textAlign: "right" }}
              >
                10M+
              </Typography>
            </Grid>
            <Grid item xs zeroMinWidth>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="h4" sx={{ fontWeight: 600 }}>
                    Documentos Assinados
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    Mais de dez milhões de documentos assinados pela plataforma.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <div>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Typography
                variant="h2"
                sx={{ minWidth: 80, textAlign: "right" }}
              >
                300Mil
              </Typography>
            </Grid>
            <Grid item xs zeroMinWidth>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="h4" sx={{ fontWeight: 600 }}>
                    Avaliações
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    300 mil usuários validaram nossa plataforma após a
                    utilização.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <div>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Typography
                variant="h2"
                sx={{ minWidth: 80, textAlign: "right" }}
              >
                4.8 &#9733;
              </Typography>
            </Grid>
            <Grid item xs zeroMinWidth>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="h4" sx={{ fontWeight: 600 }}>
                    Nota dos usuários
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    É a plataforma de assinatura com melhor avaliação do
                    mercado.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  </Container>
);

export default NumberBlock;
